import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Step } from '../../enum/step.enum';
import { ParameterLabelsView } from '../../model/parameter-labels-view.model';

@Component({
    selector: 'cmps-report-builder-selection-bar',
    templateUrl: './bar.component.html',
})
export class BarComponent {
    @Input() step: Step;
    @Input() viewParamLabels: ParameterLabelsView;
    @Input() noSelect: boolean;
    @Output() change: EventEmitter<Step>;

    /** @private */
    readonly _Step = Step;

    constructor() {
        this.change = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.change.complete();
    }
}
